var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_7173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6605 15H17.152V16.5H0.74585V15H2.23732V2.25C2.23732 2.05109 2.31589 1.86032 2.45574 1.71967C2.59559 1.57902 2.78527 1.5 2.98305 1.5H14.9148C15.1126 1.5 15.3023 1.57902 15.4421 1.71967C15.582 1.86032 15.6605 2.05109 15.6605 2.25V15ZM5.96599 8.25V9.75H8.20319V8.25H5.96599ZM5.96599 5.25V6.75H8.20319V5.25H5.96599ZM5.96599 11.25V12.75H8.20319V11.25H5.96599ZM9.69466 11.25V12.75H11.9319V11.25H9.69466ZM9.69466 8.25V9.75H11.9319V8.25H9.69466ZM9.69466 5.25V6.75H11.9319V5.25H9.69466Z",
    fill: "#686868"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_7173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8976,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompany);
export default __webpack_public_path__ + "static/media/icon_company.16f5abd1aa6f14d7c200b87fd47e5e96.svg";
export { ForwardRef as ReactComponent };